import { render, staticRenderFns } from "./ValidProcedimentos.vue?vue&type=template&id=12e386e1&"
import script from "./ValidProcedimentos.vue?vue&type=script&lang=js&"
export * from "./ValidProcedimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports